<template>
    <div class="choices-wrap" :class="{ answered: status == true }">
        <span class="libelle-note" v-for="(locales,index) in response.translations" :key="index" v-if="locales.locale === currentLocale">
            <small>{{ locales.libelle_note_min }}</small>
            <small>{{ locales.libelle_note_max }}</small>
        </span>
        <span class="choices">
            <md-radio @change="postAnswer" :disabled="civility == ''" :value="index" v-model="response_value" v-for="index in response.note_max" :key="`input-${index}`" class="md-primary" :name="`input${response.id}`">{{ index }}</md-radio>
        </span>
    </div>
</template>

<script>
import { postQuestionResponse, getQuestionResponse, postResearchQuestionResponse, getResearchQuestionResponse } from '../services/Questionnaire.service'

export default {
    name: 'Question',
    props: ['response','order','currentLocale','ifResearchQuestionnaire','isTestQuestionnaire','civility'],
    data(){
      return {
          response_value: 0,
          counter: 0,
          status: false
      };
    },
    computed:{
    },
    methods: {
        postAnswer(){
            if(this.ifResearchQuestionnaire == true){
                let data = {
                    userId: localStorage.getItem('userId'),
                    response_type: this.response_value,
                    themeId: this.response.theme.id,
                    order: this.order,
                    //questionnaireId: 14
                    //questionnaireId: 5
                    //questionnaireId: 15
                    questionnaireId: 17
                }
                postResearchQuestionResponse(data).then(resp => {
                    if(resp.data.status == 'created'){
                        this.counter = 1
                        this.status = true
                        this.$emit('counter', this.counter);
                        this.$emit('status', this.status);
                    }
                }).catch(error => {
                    console.log(error);
                })
            }else{
                let data = {
                    userId: localStorage.getItem('userId'),
                    response_type: this.response_value,
                    questionsId: this.response.question_id,
                    order: this.order,
                    //questionnaireId: this.civility == 'Monsieur' ? 21 : 20
                    questionnaireId: this.civility == 'Monsieur' ? 21 : 21
                }
                if(this.isTestQuestionnaire == true){
                  data.isQuestionnaireTest = 1
                }
                postQuestionResponse(data).then(resp => {
                    if(resp.data.status == 'created'){
                        this.counter = 1
                        this.status = true
                        this.$emit('counter', this.counter);
                        this.$emit('status', this.status);
                    }
                }).catch(error => {
                    console.log(error);
                })
            }
        },
        getUserResponse(){
            const userId = localStorage.getItem('userId');
            const q_id = this.response.question_id;
            if(this.ifResearchQuestionnaire == true){
                const respStore = JSON.parse(localStorage.getItem('talent_answers_'+userId));
                if (respStore !== null) {
                  const user_answer = respStore;
                  user_answer.map(ans =>{
                    if(q_id == ans.ordre){
                      this.response_value = ans.response
                      this.counter = 1
                      this.status = true
                      this.$emit('counter', this.counter);
                      this.$emit('status', this.status);
                    } else {
                      this.counter = 0
                    }
                  });
                }else {
                  getResearchQuestionResponse(userId).then(resp => {
                    localStorage.setItem('talent_answers_' + userId, JSON.stringify(resp.data.answers));
                    const user_answer = resp.data.answers;
                    user_answer.map(ans => {
                      if (q_id == ans.ordre) {
                        this.response_value = ans.response
                        this.counter = 1
                        this.status = true
                        this.$emit('counter', this.counter);
                        this.$emit('status', this.status);
                      } else {
                        this.counter = 0
                      }
                    });
                  }).catch(error => {
                    console.log(error);
                  });
                }
            }else{
                const respStore = JSON.parse(localStorage.getItem('answers_'+userId));
                if (respStore !== null) {
                  const user_answer = respStore;
                  user_answer.map(ans => {
                    if (q_id == ans.Reponse_Version_Question_Question) {
                      this.response_value = ans.Reponse_Version_Question_ReponseType
                      this.counter = 1
                      this.status = true
                      this.$emit('counter', this.counter);
                      this.$emit('status', this.status);
                    } else {
                      this.counter = 0
                    }
                  });
                }else {
                  getQuestionResponse(userId).then(resp => {
                    localStorage.setItem('answers_' + userId, JSON.stringify(resp.data.answers));
                    const user_answer = resp.data.answers;
                    user_answer.map(ans => {
                      if (q_id == ans.Reponse_Version_Question_Question) {
                        this.response_value = ans.Reponse_Version_Question_ReponseType
                        this.counter = 1
                        this.status = true
                        this.$emit('counter', this.counter);
                        this.$emit('status', this.status);
                      } else {
                        this.counter = 0
                      }
                    });
                  }).catch(error => {
                    console.log(error);
                  });
                }
            }
        }
    },
    mounted(){
        this.getUserResponse();
    }
}
</script>

<style scoped>
.choices-wrap {
display: flex;
flex-direction: column;
}
span.choices {
display: flex;
justify-content: space-between;
flex-wrap: wrap;
}
span.libelle-note {
display: flex;
justify-content: space-between;
margin-bottom: -15px;
color: #9e9e9e;
}
.choices-wrap span.choices div:last-child {
margin-right: 0;
}
@media (max-width: 768px){
span.choices {
margin: 5px 0 5px 0;
}
span.choices .md-radio,
span.libelle-note {
margin: 0 !important;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Question.vue